import { AuthMeUserResponse } from "@/types/auth-me.types";

/**
 * `/user/me` returns permission groups, not a flat `permissionCodes` array.
 * JWT/`userData` from elit-tools has `permissionCodes`, but the me endpoint does not.
 */
export const hasActivePermissions = (user: AuthMeUserResponse | null | undefined): boolean => {
    if (Array.isArray(user?.permissionCodes) && user.permissionCodes.length > 0) {
        return true;
    }

    if (!Array.isArray(user?.permissionGroups)) {
        return false;
    }

    return user.permissionGroups.some((group) => Array.isArray(group.permissions) && group.permissions.length > 0);
};
